import { SUPPORT_URL, WISTIA_GIT } from '@lib/constants';

const footerData = [
  {
    name: 'Platform',
    groups: [
      {
        heading: 'Platform Overview',
        links: [
          {
            label: 'The Wistia Platform',
            href: '/product',
            trackingLabel: 'product-features-overview',
          },
          {
            label: 'Product Tour',
            href: '/demo',
            trackingLabel: 'product-tour-footer',
          },
          {
            label: 'Request a Demo',
            href: WISTIA_GIT,
            trackingLabel: 'request-a-demo-footer',
          },
          {
            label: 'Pricing',
            href: '/pricing',
            trackingLabel: 'pricing-nav',
          },
        ],
      },
      {
        heading: 'Hosting',
        links: [
          {
            label: 'Video Hosting',
            href: '/product/hosting',
            trackingLabel: 'product-hosting',
          },
          {
            label: 'Embedding',
            href: '/product/embeds',
            trackingLabel: 'product-embedding',
          },
          {
            label: 'Ad-Free Player',
            href: '/product/player',
            trackingLabel: 'product-ad-free-player',
          },
          {
            label: 'Video Management',
            href: '/product/video-management',
            trackingLabel: 'product-video-management',
          },
          {
            label: 'Wistia Channels',
            href: '/product/channels',
            trackingLabel: 'product-galleries',
          },
          {
            label: 'Localization',
            href: '/product/localize',
            trackingLabel: 'product-localization',
          },
          {
            label: 'Video Podcasts',
            href: '/product/podcasting',
            trackingLabel: 'product-podcasting',
          },
          {
            label: 'Video Analytics',
            href: '/product/analytics',
            trackingLabel: 'product-analytics',
          },
        ],
      },
    ],
  },
  {
    name: 'Marketing',
    groups: [
      {
        heading: 'Video Marketing',
        links: [
          {
            label: 'Webinar Hosting',
            href: '/product/webinar-hosting',
            trackingLabel: 'product-webinar-hosting',
          },
          {
            label: 'Wistia Forms',
            href: '/product/wistia-forms',
            trackingLabel: 'product-wistia-forms',
          },
          {
            label: 'Marketing Automation',
            href: '/product/marketing-automation',
            trackingLabel: 'product-marketing-automation',
          },
          {
            label: 'Video SEO',
            href: '/product/video-seo',
            trackingLabel: 'product-seo',
          },
        ],
      },
      {
        heading: 'Video Creation',
        links: [
          {
            label: 'Video Recording',
            href: '/product/video-recording',
            trackingLabel: 'product-recording',
          },
          {
            label: 'Video Editing',
            href: '/product/video-editing',
            trackingLabel: 'product-editing',
          },
          {
            label: 'Mochine',
            href: 'https://mochine.ai',
            trackingLabel: 'product-ai-video-editing',
            openInNewTab: true,
          },
          {
            label: 'Collaboration',
            href: '/product/collaboration',
            trackingLabel: 'product-collaboration',
          },
        ],
      },
      {
        heading: 'Solutions',
        links: [
          {
            label: 'Wistia for Developers',
            href: '/product/platform',
            trackingLabel: 'product-platform',
          },
          {
            label: 'Wistia for Enterprise',
            href: '/product/enterprise-video-platform',
            trackingLabel: 'product-enterprise-video-platform',
          },
          {
            label: 'Wistia for Video Professionals',
            href: '/explore/wistia-for-video-professionals',
            trackingLabel: 'product-wistia-for-video-professionals',
          },
        ],
      },
    ],
  },
  {
    name: 'Resources',
    groups: [
      {
        heading: 'Learning Center',
        links: [
          {
            label: 'Blog',
            href: '/blog',
            trackingLabel: 'learning-center-blog',
          },
          {
            label: 'Events',
            href: '/events',
            trackingLabel: 'learning-center-webinars',
          },
          {
            label: 'Customer Stories',
            href: '/blog/category/customer-stories',
            trackingLabel: 'learning-center-customer-stories',
          },
          {
            label: 'Asset Library',
            href: '/resources/free-downloads',
            trackingLabel: 'learning-center-asset-library',
          },
        ],
      },
      {
        heading: 'Video Series',
        links: [
          {
            label: 'Video Tutorials',
            href: '/watch',
            trackingLabel: 'series-video-tutorials',
          },
          {
            label: 'Original Series',
            href: '/series',
            trackingLabel: 'series-original-series',
          },
        ],
      },
      {
        heading: 'Guides',
        links: [
          {
            label: 'State of Video Report',
            href: '/explore/state-of-video-report',
            trackingLabel: 'learning-center-state-of-video-2025',
          },
          {
            label: 'AI Video Marketing Trends',
            href: '/explore/ai-video-trends',
            trackingLabel: 'learning-center-ai-video-trends',
          },
          {
            label: 'Wistia Webinar Guidebook',
            href: '/webinarwizard',
            trackingLabel: 'learning-center-webinar-guidebook',
          },
          {
            label: 'Video Repurposing Cookbook',
            href: '/explore/video-repurposing-cookbook',
            trackingLabel: 'learning-center-video-repurposing-cookbook',
          },
          {
            label: 'Guide to Embedding Videos',
            href: '/explore/video-embedding-guide',
            trackingLabel: 'learning-center-guide-to-embedding-videos',
          },
          {
            label: 'Guide to Video Marketing',
            href: '/about/video-marketing-guide',
            trackingLabel: 'learning-center-guide-to-video-marketing',
          },
        ],
      },
    ],
  },
  {
    name: 'Support',
    groups: [
      {
        heading: 'Support',
        links: [
          {
            label: 'Help Center',
            href: '/support',
            trackingLabel: 'learning-center-help-center',
          },
          {
            label: 'Developer Docs',
            href: 'https://docs.wistia.com/',
            trackingLabel: 'learning-center-developer-docs',
          },
          {
            label: 'Product Changelog',
            href: 'https://updates.wistia.com/',
            trackingLabel: 'learning-center-product-changelog',
          },
          {
            label: 'Wistia Status',
            href: 'https://status.wistia.com/',
            trackingLabel: 'learning-center-status',
          },
          {
            label: 'Contact Support',
            href: SUPPORT_URL,
            trackingLabel: 'learning-center-contact-support',
          },
        ],
      },
      {
        heading: 'Privacy & Security',
        links: [
          {
            label: 'Security',
            href: 'https://security.wistia.com/',
            trackingLabel: 'security',
          },
          {
            label: 'AI Policy & Governance',
            href: '/privacy-ai',
            trackingLabel: 'ai-policy-governance',
          },
        ],
      },
    ],
  },
  {
    name: 'Company',
    groups: [
      {
        heading: 'Company',
        links: [
          {
            label: 'About Us',
            href: '/about',
            trackingLabel: 'about-us',
          },
          {
            label: 'Brand Assets',
            href: '/about/assets',
            trackingLabel: 'brand-assets',
          },
          {
            label: 'Careers',
            href: '/jobs',
            trackingLabel: 'careers',
          },
          {
            label: 'Company Values',
            href: '/about/values',
            trackingLabel: 'company-values',
          },
          {
            label: 'DEI & Belonging',
            href: '/about/diversity-equity-inclusion-belonging',
            trackingLabel: 'dei-belonging',
          },
          {
            label: 'Partner Program',
            href: '/partner-program',
            trackingLabel: 'partner-program',
          },
          {
            label: 'Affiliates',
            href: '/partner-program/affiliates',
            trackingLabel: 'affiliates',
          },
        ],
      },
    ],
  },
];

export default footerData;
